import { httpRequest } from '@shared/api/httpRequests'

export async function checkSso (url, data) {
  const response = await httpRequest({
    method: 'POST',
    url,
    data,
  })
  return response && response.url
}

export async function login (url, data) {
  return await httpRequest({
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    url,
    data,
  })
}
